module.exports = __webpack_public_path__ + "img/logo-w-label.4f1d48aa.png";